export const useBodyClass = (bodyClass) => {
    const globalStore = useGlobalStore();
    const { pageTransitionBeforeComplete } = storeToRefs(globalStore);
    const isMounted = ref(false);

    onMounted(() => isMounted.value = true);
    watch(
        () => pageTransitionBeforeComplete.value && isMounted.value,
        (state) => {
            if (state) {
                document.body.className = bodyClass;
            }
        }
    );
} 